import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'underscore';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Endpoint, HelpIndex, PatternOperationType } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { NameDescriptionComponent } from '../../name-description/name-description.component';
import { Pattern, PatternViewModel } from '../../../models/pattern';
import { DrObject } from '../../../models/dr-object';
import { isUndefined } from '../../../models/utils';

@Component({
    standalone: false,
    selector: 'res-pattern-modal',
    templateUrl: './pattern-modal.component.html',
    styleUrls: ['./pattern-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class PatternModalComponent extends BaseModalComponent implements OnInit {
    @ViewChild(NameDescriptionComponent, { static: true }) nameDescriptionComponent: NameDescriptionComponent;
    validateNameRequest = {
        endpoint: Endpoint.viewManager_validateName,
        request: (name) => {
            return {
                name: this.nameDescriptionComponent.name,
                objectType: 'PATTERN_TOKEN_NAME',
                projectHandle: this.modalData.currentHandle ? this.modalData.currentHandle : this.commonService.currentProject.handle
            };
        }
    };

    modalTitle = '';
    modalAutomationId = 'pattern-template';
    secondaryButtonLabel = 'Cancel';
    primaryButtonLabel = 'OK';
    verifyRequiredValidator = true;
    isBusy = false;
    isBusyMessage = '';
    modalHelpIndex = HelpIndex.add_edit_copy_pattern_dlg;
    modalClass = 'pattern-modal';
    handle = '';

    enable = true;
    storeValue = false;
    pattern = '';
    isNameDisabled = false;
    isDescriptionDisabled = false;
    isPatternDisabled = false;
    isPatternValid = false;
    showPatternPopover: boolean;
    viewModel: PatternViewModel;

    patternTypes = {
        new_pattern: {
            title: 'New Pattern',
            isBusyMessage: 'Creating a new pattern',
            endPoint: Endpoint.projectManager_createRegex
        },
        edit_custom_pattern: {
            title: 'Edit Pattern',
            isBusyMessage: 'Editing custom pattern',
            endPoint: Endpoint.projectManager_updateRegex
        },
        edit_system_pattern: {
            title: 'Edit Pattern',
            isBusyMessage: 'Editing system pattern',
            endPoint: Endpoint.projectManager_updateRegex
        },
        copy_pattern: {
            title: 'Copy Pattern',
            isBusyMessage: 'Copying Pattern',
            endPoint: Endpoint.projectManager_createRegex
        }
    };
    currentPattern: any;

    patternOperationType: PatternOperationType;

    constructor(
        private modalService: BsModalService,
        private commonService: CommonService,
        private modalRef: BsModalRef,
        private restService: RestService,
        private cdRef: ChangeDetectorRef
    ) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        this.viewModel = new PatternViewModel(new Pattern());
        this.nameDescriptionComponent.drObject = this.viewModel;
        this.patternOperationType = <PatternOperationType>this.modalData.patternOperationType;

        this.currentPattern = _.pick(this.patternTypes, this.patternOperationType);
        this.modalTitle = this.currentPattern[Object.keys(this.currentPattern)[0]].title;

        if (this.patternOperationType === PatternOperationType.edit_system_pattern) {
            this.nameDescriptionComponent.name = this.modalData.data.name;
            this.nameDescriptionComponent.description = this.modalData.data.description;
            this.pattern = this.modalData.data.expression;
            this.isNameDisabled = true;
            this.isDescriptionDisabled = true;
            this.isPatternDisabled = true;
            this.enable = this.modalData.data.enabled;
            this.storeValue = this.modalData.data.storeValue;
            this.isPatternValid = true;
        }

        if (this.patternOperationType === PatternOperationType.edit_custom_pattern) {
            this.nameDescriptionComponent.name = this.viewModel.model.name = this.viewModel.original.name = this.modalData.data.name;
            this.nameDescriptionComponent.description = this.modalData.data.description;
            if (!isUndefined(this.modalData.data.description)) {
                this.viewModel.model.description = this.viewModel.original.description = this.nameDescriptionComponent.description;
            }
            this.pattern = this.viewModel.model.expression = this.viewModel.original.expression = this.modalData.data.expression;
            this.enable = this.viewModel.model.enabled = this.viewModel.original.enabled = this.modalData.data.enabled;
            this.storeValue = this.viewModel.model.storeValue = this.viewModel.original.storeValue = this.modalData.data.storeValue;
            this.isPatternValid = true;
        }

        if (this.patternOperationType === PatternOperationType.copy_pattern) {
            this.nameDescriptionComponent.description = this.modalData.data.description;
            if (!isUndefined(this.modalData.data.description)) {
                this.viewModel.model.description = this.viewModel.original.description = this.nameDescriptionComponent.description;
            }
            this.pattern = this.viewModel.model.expression = this.viewModel.original.expression = this.modalData.data.expression;
            this.enable = this.viewModel.model.enabled = this.viewModel.original.enabled = this.modalData.data.enabled;
            this.storeValue = this.viewModel.model.storeValue = this.viewModel.original.storeValue = this.modalData.data.storeValue;
            this.isPatternValid = true;
        }

        this.cdRef.detectChanges();
    }

    onPatternChanged() {
        this.viewModel.model.expression = this.pattern;
        this.showPatternPopover = false;
    }

    toggleStoreValue(): void {
        this.viewModel.model.storeValue = this.storeValue;
    }

    toggleEnabled(): void {
        this.viewModel.model.enabled = this.enable;
    }

    onPatternFocus(): void {
        if (!this.isPatternValid && !this.showPatternPopover) {
            this.validatePattern();
        }
    }

    onPatternFocusLost(event): void {
        if (!this.showPatternPopover) {
            this.validatePattern(event);
        }
    }

    validatePattern(event?): void {
        if (this.pattern) {
            this.isBusy = true;
            this.isBusyMessage = 'Validate pattern...';
            this.restService.post(Endpoint.projectManager_validateRegex, {
                name: this.nameDescriptionComponent.name,
                description: this.nameDescriptionComponent.description,
                expression: this.pattern,
                storeValue: this.storeValue,
                enabled: this.enable,
                projectHandle: this.modalData.currentHandle ? this.modalData.currentHandle : this.commonService.currentProject.handle,
                systemScope: this.modalData?.systemScope
            }).then((response) => {
                this.isPatternValid = response?.valid;
                if (this.isPatternValid) {
                    this.showPatternPopover = false;
                    if (event?.relatedTarget?.className === 'primary-button') {
                        this.OK();
                    } else {
                        this.isBusy = false;
                    }
                } else {
                    if (!this.showPatternPopover) {
                        this.showPatternPopover = true;
                    }
                    this.isBusy = false;
                }
            })
        }
    }

    OK(): void {
        const request = {
            name: this.nameDescriptionComponent.name,
            description: this.nameDescriptionComponent.description,
            expression: this.pattern,
            storeValue: this.storeValue,
            enabled: this.enable,
            systemScope: this.modalData?.systemScope
        };

        this.isBusy = true;
        this.isBusyMessage = this.currentPattern[Object.keys(this.currentPattern)[0]].isBusyMessage;

        if (this.currentPattern[Object.keys(this.currentPattern)[0]].title === 'Edit Pattern') {
            request['handle'] = this.modalData.data.handle;
        } else {
            request['projectHandle'] = this.modalData.currentHandle;
        }

        // make api call based on the pattern operation
        this.restService.post(this.currentPattern[Object.keys(this.currentPattern)[0]].endPoint, request).then(() => {
            this.isBusy = false;
            this.closeModal(true);
        }, () => {
            this.isBusy = false;
        });

    }

    isPrimaryButtonEnabled(): boolean {
        let enabled = false;
        if (!this.isBusy) {
            if (!DrObject.isEmpty(this.nameDescriptionComponent.name) && !DrObject.isEmpty(this.pattern) && this.isPatternValid) {
                if (this.nameDescriptionComponent.isNameDirty() && (this.nameDescriptionComponent.formValid)) {
                    enabled = true;
                } else if ((this.nameDescriptionComponent.isDescriptionDirty()) && (this.nameDescriptionComponent.formValid)) {
                    enabled = true;
                } else if ((!this.nameDescriptionComponent.isDescriptionDirty() && !this.nameDescriptionComponent.isNameDirty() && this.viewModel.isDirty())) {
                    enabled = true;
                }
            }
        }
        return enabled;
    }
}
